export enum MathTextType {
  FRACTION = 'FRACTION',
  OTHER = 'OTHER',
}
